import i18n from 'app/i18/i18'

import { MyTicketItem } from 'shared/api/MyTicketsModel'
import { TicketItem } from 'shared/models/ticket'

import {
  getBaggageInfoNew,
  getExchangeInfoNew,
  getRefundInfoNew,
  getСBaggageInfoNew,
} from '../../tariff-family-card/lib/get-additional-info-new'

export const getInfoTicket = (ticket: TicketItem) => {
  const baggage = ticket?.segments?.[0]?.baggage
  const cbaggage = ticket?.segments?.[0]?.cbaggage

  return {
    price: ticket?.price?.KGS,
    fareFamilyType: ticket?.fare_family_type,
    isMplus: ticket?.is_mplus,
    mplusAmount: ticket?.mplus_amount,
    monthlyTranche: ticket?.monthly_tranche,
    additionalInfo: [
      getBaggageInfoNew(ticket?.is_baggage, baggage, i18n.t),
      getСBaggageInfoNew(ticket?.is_cbaggage, cbaggage, i18n.t),
      getRefundInfoNew(ticket?.refund, i18n.t),
      getExchangeInfoNew(ticket?.trade, i18n.t),
    ],
  }
}

export const getInfoTicketMyTicket = (ticket: MyTicketItem) => {
  const baggage = ticket?.flight_details?.flight?.segments?.[0]?.baggage || null
  const cbaggage =
    ticket?.flight_details?.flight?.segments?.[0]?.cbaggage || null

  return {
    price: ticket?.price,
    fareFamilyType: ticket?.fare?.fare_family_type,
    isMplus: ticket?.is_mplus,
    mplusAmount: ticket?.mplus_amount,
    monthlyTranche: ticket?.tranche_amount,
    additionalInfo: [
      getBaggageInfoNew(ticket?.fare?.is_baggage, baggage, i18n.t),
      getСBaggageInfoNew(ticket?.fare?.is_cbaggage, cbaggage, i18n.t),
      getRefundInfoNew(ticket?.fare?.refund, i18n.t),
      getExchangeInfoNew(ticket?.fare?.trade, i18n.t),
    ],
  }
}
